import React, { useEffect } from 'react';
import {
  getDefaultEntityListsParams,
  useGetEntityListsQuery,
} from '../../../screens/ProjectAdministration/EntityListAdministration/apiEntityLists';
import { EntityListResponse, EntityListSourceType, EntityListTypeName } from '@ydistri/api-sdk';

interface TypeLoaderProps {
  type: EntityListTypeName;
  sourceType?: EntityListSourceType;
  onLoaded: (type: EntityListTypeName, lists: EntityListResponse[]) => void;
  onLoading: (loading: boolean) => void;
}

// Sub-component that loads lists for a single type and reports them to parent
export const TypeLoader: React.FC<TypeLoaderProps> = ({
  type,
  sourceType,
  onLoaded,
  onLoading,
}) => {
  const { data, isFetching } = useGetEntityListsQuery(
    getDefaultEntityListsParams(type, sourceType),
  );

  useEffect(() => {
    onLoading(isFetching);
  }, [isFetching, onLoading]);

  useEffect(() => {
    if (data) onLoaded(type, data);
  }, [data, type, onLoaded]);

  return null;
};
